import {
  Checkbox,
  Flex,
  CheckboxProps as RadixCheckboxProps,
  Text,
} from "@radix-ui/themes";

interface CheckboxProps extends RadixCheckboxProps {
  label?: string;
}

function CheckboxComponent({ label, size = "3", ...props }: CheckboxProps) {
  return (
    <Text as="label" className="select-none leading-none">
      <Flex as="span" gap="4" align="center">
        <Checkbox {...props} size={size} />
        {label}
      </Flex>
    </Text>
  );
}

export { CheckboxComponent as Checkbox };
